import { User } from '@vsolv/core/users/domain';
import { Customer } from '@wsphere/customers/domain';
import { Claim } from '..';
import { Status } from './status';

export enum PaymentActions {
  CREATED = 'CREATED',
  ISSUED = 'ISSUED',
  UPDATED = 'UPDATED',
  VOIDED = 'VOIDED',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
}

export interface Model {
  id: string;

  created: Date;
  modified: Date;

  title: string;
  description: string | null;

  referenceId: string | null;

  status: Status;

  destination: string | null;

  amount: number;

  /** The authorization this payment is paid against; null on payments made before authorizations. */
  authorizationId: string | null;
  authorizationReference: string | null;
  /** The authorization's net payable when the payment was created, in cents. */
  authorizedPayable: number | null;

  /** The share of the split this payment pays; null on payments made before allocations. */
  allocationId: string | null;

  /** Copied from the allocation, or the authorization before allocations; null on payments made before payees. */
  payeeType: Claim.Authorization.PayeeType | null;
  payeeId: string | null;
  payeeName: string | null;

  claim?: Claim.Model;
  claimId: string;

  customerId: string;
  customer?: Customer.Model;

  deleted: Date | null;

  createdBy?: User.Model;
  createdById: string;

  deletedBy?: User.Model;
  deletedById?: string;

  visibleToCustomer: boolean;
}
